import { useEffect, useState } from 'react'
import Overlay from '../Overlay'
import Spinner from '../Spinner'

interface ErrorOrLoadingType {
  useErrorMessage?: boolean
  error?: Error
  loading: boolean
}

const ErrorOrLoading = ({
  error,
  loading,
  useErrorMessage
}: ErrorOrLoadingType) => {
  const [errorMessage, setErrorMessage] = useState<string>('')
  useEffect(() => {
    if (!error) {
      setErrorMessage('')
    } else {
      console.log(error)
      setErrorMessage(
        useErrorMessage
          ? error.message
          : 'Whoops, it looks like something went wrong. Please, try refreshing the page. If the issue continues, please contact us on 13 13 85'
      )
    }
  }, [error])
  return error || loading ? (
    <Overlay mode={error ? 'dark' : 'light'}>
      {loading && !error && <Spinner />}
      {!!error && <h2 className="maxWidth600">{errorMessage}</h2>}
    </Overlay>
  ) : (
    <></>
  )
}

export default ErrorOrLoading
